export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7311.b482a056.jpg";